import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persister } from "./store";
import Loader from "./Loader/Loader";
// import FinalPanchayath from "./FinalPanchayath";
// import LoginPage from "./LoginPage";
import CentralizedRoutes from "./routes/CentralizedRoutes";


const RoutesComponent = () => {
    return (
        <PersistGate loading={null} persistor={persister}>
            <Router>
                <Suspense fallback={<div className="page-loader">Loading…</div>}>
                    <CentralizedRoutes />
                    {/* <Routes>
                        <Route path="/" element={<FinalPanchayath />} />
                        <Route path="/loginpage" element={<LoginPage />} />
                    </Routes> */}
        
                </Suspense>


            </Router>
            <Loader />
        </PersistGate>

    );
};

export default RoutesComponent;


